/**
 * Universal App & UI Configuration
 * Centralized configuration file for all initial values, toggles, and settings
 * consumed across the application (Admin panel, Themes panel, Cursor, and Animations).
 */

export const APP_CONFIG = {
  // Admin / Edit Mode
  enableEditMode: false, // true | false: default value for 'Enable Edit Mode' toggle in Admin panel

  // Dark / Light mode
  theme: "light", // "light" | "dark"
  darkModeIntensity: "balanced", // "soft" | "balanced" | "deep"
  lightModeIntensity: "balanced", // "soft" | "balanced" | "deep"

  // Animations
  animationEnabled: true, // true | false (master toggle)
  animationMode: "css", // "framer-motion" | "css" | "none"

  // Liquid Glass Effect
  glassEnabled: true,
  glassBlur: 12, // in px
  glassOpacity: 0.1, // 0 to 1
  glassSaturation: 180, // in %
  selectedGlassTexture: "clear", // "clear" | "texture1" | "texture2" | "texture3" | "texture4" | "texture5"

  // Glass Cursor (Desktop Only)
  glassCursorEnabled: false,

  // Background Color-Mix
  useColorMixBg: false,
  colorMixPercent: 10, // in %

  // Default Themes (index of active default theme, 0 is clear/none, 2 is default page load theme)
  activeThemeInDefaultThemes: 2,

  // Custom Themes
  enableColors: false, // toggle for custom theme mode
  activeThemeInCustomThemes: 0,

  // Accordion open sections by default
  defaultExpandedSections: ["darkMode", "defaultThemes"],
};

// Backward-compatibility alias
export const THEME_CONFIG = APP_CONFIG;

export default APP_CONFIG;
